import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

import en from '../i18n/en'
import es from '../i18n/es'
import ja from '../i18n/ja'

const messages = {
  en: en,
  es: es,
  ja: ja
}

// Create VueI18n instance with options
export default new VueI18n({
  locale: 'es', // set locale
  messages, // set locale messages
})